import { request } from './request';

// 计算运费和税费的接口响应类型
interface ComputeResponse {
  success: boolean;
  data?: {
    subtotal: number;
    shipping: number;
    tax: number;
    total: number;
  };
  message?: string;
}

// 计算运费和税费的函数
export const calculateShippingAndTax = async (subtotal: number): Promise<{
  shipping: number;
  tax: number;
  error?: string;
}> => {
  try {
    const response: any = await request({
      method: 'POST',
      url: 'compute/calculate',
      data: { subtotal }
    });

    if (response.success) {
      return {
        shipping: response.result.shipping,
        tax: response.result.tax
      };
    } else {
      console.error('计算运费和税费失败:', response.message);
      // 使用默认值
      return {
        shipping: subtotal > 30 ? 0 : 5.99,
        tax: 0,
        error: response.message
      };
    }
  } catch (error) {
    console.error('计算运费和税费出错:', error);
    // 使用默认值
    return {
      shipping: subtotal > 30 ? 0 : 5.99,
      tax: 0,
      error: error instanceof Error ? error.message : 'Unknown error'
    };
  }
};
